import { InfoInput } from '@p2p/components';
import { isSberBabilonM } from '@p2p/pages/Redirect/deeplink/deeplink.utils';
import { PaymentType } from '@p2p/shared/constants';
import { formatPhoneNumber, stripCountryCode } from '@p2p/shared/functions';

import { RequisitesProps } from './Requisites.types';

// P2P-2613: только для sber + Babilon-M (Таджикистан) — без кода страны +992
// (клиенту удобнее вставить «голый» номер в приложение банка) и с копированием
// суммы перевода (как и номер/карта, копируется то же значение, что отображается).
const BABILON_COUNTRY_CODE = '+992';

export const Requisites = ({ order }: RequisitesProps) => {
  if (
    ![PaymentType.PAYMENT_TYPE_SBP, PaymentType.PAYMENT_TYPE_C2C].includes(
      order.requisite.payment_type as PaymentType,
    )
  ) {
    return null;
  }

  const isSBP = order.requisite.payment_type === PaymentType.PAYMENT_TYPE_SBP;
  const isC2C = order.requisite.payment_type === PaymentType.PAYMENT_TYPE_C2C;
  const isBabilonSber = isSberBabilonM(order);
  const formattedPhone = formatPhoneNumber(order.requisite.phone_number || '');
  const phone = isBabilonSber
    ? stripCountryCode(formattedPhone, BABILON_COUNTRY_CODE)
    : formattedPhone;
  const accountNumber = order.requisite.account_number;
  const expectedIncome = Number(order.expected_income || 0)
    .toFixed(2)
    .toString();

  // P2P-2746: согласовано — поле "Получатель" всегда скрываем, если его значение
  // полностью дублирует "Банк получателя" (кейс Sber + Babilon-M, где ФИО = "Babilon-M",
  // но условие сделано общим, а не привязано к isBabilonSber).
  const bankName = (order?.requisite.bank.name || '').trim().toLowerCase();
  const recipient = (order.requisite.fio || '').trim().toLowerCase();
  const isDuplicateRecipient = !!recipient && recipient === bankName;

  return (
    <>
      {isSBP && <InfoInput label="Номер телефона" value={phone} canCopy />}
      {isC2C && <InfoInput label="Номер карты" value={accountNumber} canCopy />}
      <InfoInput label="Банк получателя" value={order?.requisite.bank.name || 'Банк не найден'} />
      {!isDuplicateRecipient && <InfoInput label="Получатель" value={order.requisite.fio} />}
      {isBabilonSber && <InfoInput label="Сумма перевода" value={expectedIncome} canCopy />}
    </>
  );
};
